import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as customerActions from '../Actions/customerActions';
import * as languageActions from '../Actions/languageActions';
import { Link } from 'react-router-dom';
import {languageService} from "../Services/LanguageService.js";
import { customerService } from "../Services/CustomerService.js";
import { userService } from "../Services/UserService.js";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { normalize } from 'normalizr';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import {  orderSchema, userSchema, customerSchema, customerListSchema } from '../Schemas/OrderSchema.js';
import { orderService } from "../Services/OrderService.js";

class UserConfigurationContainer extends Component {
	constructor(props) {
		super(props);
		this.state={
			products: [],
			ratings: [],
			orders: []
		};
		this.fetchCustomerRecords = this.fetchCustomerRecords.bind(this);
		this.orderCustomers = this.orderCustomers.bind(this);
		this.drawRatings = this.drawRatings.bind(this);
		this.sortRatings = this.sortRatings.bind(this);
		this.getOrders = this.getOrders.bind(this);
	}
	
	componentDidMount() {
		customerService.listCustomers()
					.then(response => this.fetchCustomerRecords(response.data))
					.then(response => userService.getRatings(this.props.userId))
					.then(response => { this.setState({ratings: response.data}); this.getOrders(response.data); return 1;})
					.catch(err => {/*console.log(err);*/});
	}
		
	getOrders(ratings){
		ratings.forEach(rtg => {
			orderService.getOrder(rtg.sample)
				.then(response => {
						let orders = this.state.orders;
						orders.push(response.data);
						this.setState({orders: orders});
						return 1;
					})
				.catch(err => {/*console.log(err);*/});
		});
	}
	
	fetchCustomerRecords(responseData){
		var normalizedData = normalize(responseData, customerListSchema);
		this.props.actions.fetchCustomerRecords(normalizedData.entities.customers);
		this.props.actions.fetchLanguagePairs(normalizedData.entities.languagePairs);
		return 1;
	}
	
	orderCustomers(a, b){
		return a.name.localeCompare(b.name);
	}
	sortRatings(a, b){
		if(typeof a.quarter == "undefined"){
			if(typeof b.quarter == "undefined"){
				return 0;
			}
			return 1;
		}
		if(typeof b.quarter == "undefined"){
			return -1;
		}
		if((a.year-b.year)!==0){
			return a.year-b.year;
		}else{
			return a.quarter-b.quarter;
			//return((Number(a.lastTerm.quarter) < Number(b.lastTerm.quarter)) ? 1 : ( (Number(a.lastTerm.quarter) > Number(b.lastTerm.quarter)) ? -1 : 0))
		}
	}
	 "type": "RATING"
	drawRatings(){
		if(typeof(this.state.ratings)!="undefined" && this.state.ratings.length>0 && typeof(this.state.orders)!="undefined"){
			let rows = [];
			let terms = [" - Inicial", " - I"," - II"," - III"," - IV"];
			let sorted = [...this.state.ratings];
			sorted.sort(this.sortRatings);
			sorted.forEach( element => {if(element.style>0 && element.grammarortog>0 && element.localization>0){
				let order = this.state.orders.find(ord => ord.id==element.sample);
				var ratingPhase;
				if(typeof(order)!="undefined"){
					ratingPhase = order.phase.find(phase => phase.type=="RATING")
				}
				rows.push(
					<TableRow>
						<TableCell>{element.id}</TableCell>
						<TableCell>{element.year}{terms[element.quarter]}</TableCell>
						<TableCell>{element.style}</TableCell>
						<TableCell>{element.grammarortog}</TableCell>
						<TableCell>{element.localization}</TableCell>
						<TableCell>{typeof(ratingPhase)!="undefined" && ratingPhase.user.username}</TableCell>
						<TableCell>{typeof(order)!="undefined" && order.code}</TableCell>
						<TableCell>{typeof(order)!="undefined" && order.reference}</TableCell>
					</TableRow>
				)
			}})

			return (<Table className="lst">
						<TableHead>
							<TableRow>
								<TableCell>id</TableCell>
								<TableCell>Term</TableCell>
								<TableCell>Estilistic</TableCell>
								<TableCell>Gramatic/ortografic</TableCell>
								<TableCell>Localization</TableCell>
								<TableCell>Rater</TableCell>
								<TableCell>Code</TableCell>
								<TableCell>Original Translation</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
						{rows}
						</TableBody>
					</Table>)
		}else{
			return "";
		}
	}
	
	render() {
		let customers = [];
		Object.values(this.props.customerRecords).sort(this.orderCustomers).forEach(
			customer => {
				let products = [];
				customer.product.forEach( 
					product => {
						//let supplier = this.props.supplierConfigRecords[configuration].supplier
						if(product.suppliers.reduce((acum, val)=> acum || (this.props.supplierConfigRecords[val] != 'undefined' && this.props.supplierConfigRecords[val].supplier==this.props.userId), false)){
							let p = {	id: product.id,
										name: product.name,
										workflow: product.workflow,
										wfConfig: product.wfConfig,
										langPair: product.langPair
							}
							if(typeof this.props.langPairs[product.langPair] != 'undefined'){
								products.push(<li><strong>{product.name}:</strong> {this.props.langPairs[product.langPair].code}</li>);
							}
						}
					}
				)
				if(products.length>0) {
					let c={	id: customer.id,
							name: customer.name,
							products: products
					}
					customers.push(<li><span style={{fontSize: "16px", color: "#1236bc", fontWeight:"bold"}}>{customer.name}</span><ul>{products}</ul></li>);
				}												
			}
		);
		
		let ratings = [];
		
		
		return(
			<div className="row">
				<div className="col">
					<ul>{customers}</ul>
				</div>
				<div className="col">
					<h5>RATINGS:</h5>
					{this.drawRatings()}
				</div>
			</div>
		);
	}
}

function mapStateToProps(state, ownProps) {  
	return {userId: ownProps.match.params.id,
			customerRecords: state.customers,
			supplierConfigRecords: state.supplierConfiguration,
			langPairs: state.languagePairs,
			user: state.user,
			search: state.search.searchString}
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(Object.assign({}, customerActions, languageActions), dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserConfigurationContainer);